// extracted by mini-css-extract-plugin
export default {"cls1":"Tpy44Qwfvkf0ekxfQjsf","cls2":"ZCYxVxMjdEoBn68NfrXO Tpy44Qwfvkf0ekxfQjsf"};